import { useMutation, UseMutationOptions } from "@connectrpc/connect-query";
import { useQueryClient } from "@tanstack/react-query";

import {
  createSource,
  deleteSource,
  updateSource,
} from "@gx/ts-contracts/services/source/api/source-SourceService_connectquery";

import { createListSourcesInfiniteQueryKey } from "@/api/queries/sources";
import { createGetTenantUsageQueryKey } from "@/api/queries/tenant-plan";

export const useCreateSourceMutation = (
  options?: UseMutationOptions<typeof createSource.input, typeof createSource.output>,
) => {
  const queryClient = useQueryClient();
  return useMutation<typeof createSource.input, typeof createSource.output>(createSource, {
    ...options,
    onSuccess: (data, variables, onMutateResult, context) => {
      void queryClient.invalidateQueries({
        queryKey: createListSourcesInfiniteQueryKey(),
      });
      void queryClient.invalidateQueries({
        queryKey: createGetTenantUsageQueryKey(),
      });
      if (options?.onSuccess) {
        options.onSuccess(data, variables, onMutateResult, context);
      }
    },
  });
};

export const useUpdateSourceMutation = (
  options?: UseMutationOptions<typeof updateSource.input, typeof updateSource.output>,
) => {
  const queryClient = useQueryClient();
  return useMutation<typeof updateSource.input, typeof updateSource.output>(updateSource, {
    ...options,
    onSuccess: (data, variables, onMutateResult, context) => {
      void queryClient.invalidateQueries({
        queryKey: createListSourcesInfiniteQueryKey(),
      });
      if (options?.onSuccess) {
        options.onSuccess(data, variables, onMutateResult, context);
      }
    },
  });
};

export const useDeleteSourceMutation = (
  options?: UseMutationOptions<typeof deleteSource.input, typeof deleteSource.output>,
) => {
  const queryClient = useQueryClient();

  return useMutation<typeof deleteSource.input, typeof deleteSource.output>(deleteSource, {
    onSuccess: (data, variables, context, meta) => {
      void queryClient.invalidateQueries({
        queryKey: createListSourcesInfiniteQueryKey(),
      });
      if (options?.onSuccess) {
        options.onSuccess(data, variables, context, meta);
      }
    },
    ...options,
  });
};
